'use client';

import { GoogleTagManager } from '@next/third-parties/google';

import DriftWidget from '@/app/components/ui/Drift/DriftWidget';

export default function ThirdPartyScripts({ gtmId }: { gtmId: string }) {
  return (
    <>
      <GoogleTagManager gtmId={gtmId} />

      <DriftWidget />

      {/* Note: Chili Piper is managed by useChiliPiper hook */}
    </>
  );
}
